var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7398 27.8023C13.4055 28.6379 14.383 29.1786 15.4561 29.3049C16.5292 29.4312 17.6094 29.1326 18.4575 28.4751C18.7184 28.2807 18.9531 28.0546 19.1561 27.8023M4.6676 18.3828V18.0908C4.71044 17.227 4.9873 16.3899 5.46964 15.6661C6.27251 14.7966 6.82211 13.731 7.06079 12.5813C7.06079 11.6926 7.06079 10.7913 7.13841 9.90266C7.53943 5.62451 11.7695 2.66663 15.9479 2.66663H16.0514C20.2298 2.66663 24.4599 5.62451 24.8738 9.90266C24.9515 10.7913 24.8738 11.6926 24.9385 12.5813C25.1804 13.7337 25.7295 14.8026 26.5297 15.6788C27.0156 16.3962 27.2929 17.2302 27.3317 18.0908V18.3701C27.3606 19.5307 26.9609 20.6624 26.2063 21.5565C25.2091 22.6019 23.856 23.2523 22.403 23.3845C18.1425 23.8416 13.8439 23.8416 9.58333 23.3845C8.13203 23.2466 6.78085 22.5972 5.78011 21.5565C5.03717 20.6617 4.64282 19.5367 4.6676 18.3828Z",
    stroke: "#4F5163",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.e4bc4cf85b3d21e569d026eddea212bd.svg";
export { ForwardRef as ReactComponent };